// **************** common import *******************
import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "../../../utils/redirections";
import CommonHeader from "../../../components/common-header";

// *****************************
import Table from "../../../components/table/table";
import { toast} from "react-toastify";

// ******************************** API
import { FetchMappedPatientList } from "../../../redux/slices/mapping.slice";
import { MappedPatientDeleteAPI } from "../../../api/delete";


// INCON
import EditIcon from "../../../assets/icons/edit.png";
import DeleteIcon from "../../../assets/icons/trash.png";

//edit modal
import {PatientMapPopup} from "./patient-map-popup"

//delete modal
import { ConfirmPopup } from "../../../components/model-popup/confirmation-popup";
import { CustomButton } from "../../../components/buttons/button";
import { WordTitle } from "../../../utils/commonFunction";

// interface 
import { ChildProps } from "../../../utils/types/interFace";

const PatientMapping = ({filteredAccess}:ChildProps) => {
  const dispatch: any = useDispatch();
  const [loader, setLoader] = useState<boolean>(true);
  const userAccess = filteredAccess.length !== 0 ? filteredAccess[0] : {}
  const MappedPatientList = useSelector(
    (state: any) => state?.MappedDataList?.MappedPatientList || []
  );


  // search
  const [showSearch, setShowSearch] = useState("");
  const [search, setSearch] = useState<string>("");
  const handleSearch = useCallback(debounce(setSearch, 500), []);

  // sort
  const [sort, setSort] = useState<string>("created_at");
  const [sortDir, setSortDir] = useState<string>("asc");

  const [limit, ] = useState<number>(15);
  const [page, setPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [totalRecord, setTotalRecord] = useState<number>(0);

  // editview
  const [ViewDetails, setViewDetails] = useState<any>({});
  const [showModal, setShowModal] = useState<boolean>(false);

  // delete
  const [showDeleteModel, setShowDeleteModel] = useState<boolean>(false);
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [multiDelete, setMultiDelete] = useState<any>(false);


  // handle the loading the data
  const handlePatientListData = (param:any = {}) => {
    const apiParam:any = {page:page,
      limit:limit,
      search_value:search,
      sort_by:sort,
      sort_dir:sortDir}
    if ('page' in param){
      apiParam['page'] = param['page']
      setPage(param['page'])
    } 
    if ('sort' in param) {
      apiParam['sort_by'] = param['sort'];
      apiParam['sort_dir'] = param['sortDir'];
      apiParam['page'] = 1
      setSort(param['sort'])
      setSortDir(param['sortDir'])
      setPage(1)
    } 
    if ('search' in param) {
      apiParam['search_value'] = param['search'];
      apiParam['page'] = 1
      setPage(1)
    }
    if (apiParam['page'] === 1){
      setLoader(true)
      setSelectedRows([]);
    }
    dispatch(
      FetchMappedPatientList(apiParam)
    ).then((res: any) => {
      setTotalPage(res?.payload?.result?.total_pages);
      setTotalRecord(res?.payload?.result?.total_count);
      setLoader(false);
    });
  };

  const handleNextPage = () => {
    handlePatientListData({'page':page + 1});
  };

  const afterChangePatientList = () => {
    handlePatientListData({'page':1});
  };

  const handleDelete = async () => {
    setButtonLoader(true);
    const mappedPatient_list = { ids: [ViewDetails?.id]};
    await MappedPatientDeleteAPI(mappedPatient_list).then((res: any) => {
      setShowDeleteModel(false);
      if (res?.success) {
        afterChangePatientList();
        setMultiDelete(false)
        setViewDetails({});
        toast.success(res?.message);
      } else {
        toast.error(res?.message || res?.detail?.message || "Patient mapping delete failed");
      }
      setButtonLoader(false);
    });
  };

  const handleMultiDelete = async () => {
      setButtonLoader(true);
      const selectedIds = selectedRows.map((row: any) => row?.id);
      const mappedPatient_list = { ids: selectedIds };
      await MappedPatientDeleteAPI(mappedPatient_list).then(async (res: any) => {
        setShowDeleteModel(false);
        if (res?.success) {
          setViewDetails({});
          setMultiDelete(false);
          setSelectedRows([]);
          afterChangePatientList()
          toast.success(res?.message);
        } else {
          toast.error(res?.message || res?.detail?.message || "Patient mapping delete failed");
        }
        setButtonLoader(false);
      });
    };



  const handleClose = () => {
    setShowModal(false);
    setViewDetails({});
    setMultiDelete(false);
    setSelectedRows([]);
  };

  
  useEffect(() => {
     handlePatientListData({'search':search});
  }, [search]);

  useEffect(() => {
      handleSearch(showSearch);
    }, [showSearch]);

  return (
    <div className="w-full p-[10px] pl-[2px] pr-[2px]">
      <div className="pt-[16px]  pl-[2px] pr-[2px] bg-white rounded-[12px]">
        <CommonHeader
          heading="Patient ID Mapping"
          description="This table maps system-generated patient identifiers across platforms to ensure accurate and consistent patient recognition."
          totalCount={totalRecord}
          countForText="Results"
          setShowSearch={setShowSearch}
          showSearch={showSearch}
          search
        />
        <Table
          loading={loader}
          data={MappedPatientList}
          // showCheckbox={userAccess.delete_access}
          tableScroll={"100%"}
          sort={true}
          // showCheckboxCondition = {showCheckboxCondition}
          // setSelectedRows={setSelectedRows}
          // MultiDeletedFucn={() => {
          //   setMultiDelete(true);
          //   setTimeout(() => {
          //     setShowDeleteModel(true);
          //   }, 10);
          // }}
          // selectedRows={selectedRows}
          hasNextPage={page < totalPage}
          NextPageData={handleNextPage}
          columns={[
            "Patient",
            "DOB",
            "Gender",
            "Mapped Patient",
            "Mapped DOB",
            "Mapped Gender",
            "Updated By",
            ...(userAccess.delete_access || userAccess.update_access ? ["Action"] : [])
          ]}
          sortTitleKeys={{
            Patient: "source_last_name",
            DOB: "source_birth_date",
            Gender: "source_gender",
            "Mapped Patient": "patient_last_name",
            "Mapped DOB": "patient_birth_date",
            "Mapped Gender": "patient_gender",
            "Updated By": "update_by_last_name",
          }}
          handleSortfunc={(key: any, value: any) => {
            handlePatientListData({'sort':key,'sortDir':value})
          }}
          scopedSlots={{
            Patient: ({ row }: any) => (
              <td title={`${row?.source_last_name || ""} ${row?.source_first_name || ""}`}>
                
                  <div className="max-w-[200px] truncate ">
                    {![null, ""].includes(row.source_last_name) &&
                      ![null, ""].includes(row.source_first_name)
                      ? `${WordTitle(row.source_last_name)}, ${WordTitle(row.source_first_name)}`
                      : WordTitle(row.source_last_name) || WordTitle(row.source_first_name)}
                  </div>
                
              </td>
            ),
            DOB: ({ row }: any) => (
              <td title={row?.source_birth_date || ""}>
                <div className=" max-w-[150px] truncate ">
                  {row?.source_birth_date || ""}
                </div>
              </td>
            ),
            Gender: ({ row }: any) => (
              <td title={row?.source_gender || ""}>
                <div className=" max-w-[150px] truncate ">
                  {row?.source_gender ? WordTitle(row?.source_gender) : ''}
                </div>
              </td>
            ),
            "Mapped Patient": ({ row }: any) => (
              <td title={`${row?.patient_last_name || ""} ${row?.patient_first_name || ""}`}>
                  <a
                    href={`/patient-lookup/${row?.patient_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline text-blue-500"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <div className="max-w-[200px] truncate ">
                      {![null, ""].includes(row.patient_last_name) &&
                        ![null, ""].includes(row.patient_first_name)
                        ? `${WordTitle(row.patient_last_name)}, ${WordTitle(row.patient_first_name)}`
                        : WordTitle(row.patient_last_name) || WordTitle(row.patient_first_name)}
                    </div>
                  </a>
              </td>
            ),
            "Mapped DOB": ({ row }: any) => (
              <td title={row?.patient_birth_date || ""}>
                <div className=" max-w-[150px] truncate ">
                  {row?.patient_birth_date || ""}
                </div>
              </td>
            ),
            "Mapped Gender": ({ row }: any) => (
              <td title={row?.patient_gender || ""}>
                <div className=" max-w-[150px] truncate ">
                  {row?.patient_gender ? WordTitle(row?.patient_gender) : ''}
                </div>
              </td>
            ),
            "Updated By": ({ row }: any) => (
              <td title={`${row?.update_by_last_name || ""} ${row?.update_by_first_name || ""}`}>
                
                  <div className="max-w-[200px] truncate ">
                    {![null, ""].includes(row.update_by_last_name) &&
                      ![null, ""].includes(row.update_by_first_name)
                      ? `${WordTitle(row.update_by_last_name)}, ${WordTitle(row.update_by_first_name)}`
                      : WordTitle(row.update_by_last_name) || WordTitle(row.update_by_first_name)}
                  </div>
                
              </td>
            ),
            Action: ({ row }: any) => {
              const isRemovedOrCompleted = row.status ? (row.status.toLowerCase() === "removed" || row.status.toLowerCase() === "completed"):'';
              return (
                <td>
                  <div className="flex gap-[16px] items-center justify-center pr-[4px]">
                  {selectedRows.length <= 1 && 
                  <>
                    { !isRemovedOrCompleted &&
                      userAccess.update_access && 
                      <img
                        src={EditIcon}
                        alt="Edit"
                        className="cursor-pointer w-[18px] h-[18px]"
                        onClick={(e) => {
                          e.stopPropagation(); 
                          setViewDetails(row);
                          setShowModal(true);
                        }}
                      />
                    }
                     
                     {
                      !isRemovedOrCompleted && userAccess.delete_access && 
                      <img
                        src={DeleteIcon}
                        onClick={(e) => {
                          e.stopPropagation(); 
                          setMultiDelete(false)
                          setShowDeleteModel(true);
                          setViewDetails(row);
                        }}
                        alt="Delete"
                        className="cursor-pointer w-[18px] h-[18px]"
                      />
                     }
                  </>
                  }
                  </div>
                </td>
              );
            },
          }}
        />
      </div>

      <ConfirmPopup showModal={showDeleteModel} icon>
        <div className="text-[16px] font-semibold text-center text-[#061018] line-height-[24px]">
          Remove Notes?
        </div>
        <div className="text-[12px] font-normal text-center text-[#061018] mt-[8px] mb-[16px] ">
          You are about to delete{" "}
          <span className="font-semibold">
            {multiDelete
              ? `${selectedRows?.length} Patient Mapping`
              : `“${![null, ""].includes(ViewDetails.source_last_name) &&
                      ![null, ""].includes(ViewDetails.source_first_name)
                      ? `${WordTitle(ViewDetails.source_last_name)}, ${WordTitle(ViewDetails.source_first_name)}`
                      : WordTitle(ViewDetails.source_last_name) || WordTitle(ViewDetails.source_first_name)}” patient`}
          </span> {" "}
          Are you sure you want to continue?
        </div>
        <div className="flex justify-center gap-[16px] items-center w-full">
          <CustomButton
            buttonName="No, Keep it"
            primary={false}
            buttonStyle="w-full text-[#1C252D] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px]   "
            disable={buttonLoader}
            onClick={() => {
              setShowDeleteModel(false);
              setViewDetails({});
            }}
          />
          <CustomButton
            buttonName="Yes, Remove !"
            buttonStyle="w-full text-white bg-[#D41E1E] hover:bg-[#B51C1C] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px]   "
            loader={buttonLoader}
            disable={buttonLoader}
            loaderStyle="w-full bg-[#D41E1E]/80  py-[13px] "
            onClick={() => {
              multiDelete ? handleMultiDelete() : handleDelete();
            }}
          />
        </div>
      </ConfirmPopup>

      <PatientMapPopup
        showModal={showModal}
        setShowModal={setShowModal}
        handleClose={handleClose}
        poupDetails={ViewDetails}
        afterChangeNotesList={afterChangePatientList}
      />

    </div>
  );
};

export default PatientMapping;